var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterSectionYoutubeBgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9845 2.75243C16.8945 2.39291 16.7113 2.0635 16.4532 1.79748C16.1952 1.53146 15.8715 1.33825 15.5149 1.23735C14.2119 0.91919 9.00008 0.919189 9.00008 0.919189C9.00008 0.919189 3.78823 0.919189 2.48527 1.26766C2.12866 1.36855 1.80498 1.56176 1.54694 1.82778C1.2889 2.0938 1.10563 2.42321 1.01565 2.78273C0.777186 4.10505 0.660542 5.44646 0.667181 6.7901C0.658681 8.14385 0.775333 9.49549 1.01565 10.8278C1.11485 11.1761 1.30223 11.493 1.55967 11.7478C1.81711 12.0026 2.13591 12.1866 2.48527 12.2822C3.78823 12.6307 9.00008 12.6307 9.00008 12.6307C9.00008 12.6307 14.2119 12.6307 15.5149 12.2822C15.8715 12.1813 16.1952 11.9881 16.4532 11.7221C16.7113 11.4561 16.8945 11.1267 16.9845 10.7672C17.2211 9.4548 17.3378 8.12361 17.333 6.7901C17.3415 5.43634 17.2248 4.08471 16.9845 2.75243Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29565 9.26728L11.6515 6.79013L7.29565 4.31299V9.26728Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSectionYoutubeBgBlack);
export default __webpack_public_path__ + "static/media/footer_section_youtube_bg_black.ff4b95845a7567c7c53c8073129bb33d.svg";
export { ForwardRef as ReactComponent };